import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  rating?: number;
}
export function TestimonialCard({
  quote,
  author,
  role,
  rating = 5
}: TestimonialCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col" data-id="element-370">
      <div className="flex mb-4" data-id="element-371">
        {[...Array(rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-372" />)}
      </div>
      <p className="text-gray-700 mb-6 flex-1 italic" data-id="element-373">"{quote}"</p>
      <div data-id="element-374">
        <p className="font-bold text-[#0B1F3A]" data-id="element-375">{author}</p>
        <p className="text-sm text-gray-500" data-id="element-376">{role}</p>
      </div>
    </div>;
}